<template>
  <v-list-item
    class="vertical-nav-menu-link"
    v-bind="$attrs"
    active-class="bg-gradient-primary white--text"
  >
    <v-list-item-icon>
      <svg
        v-if="svgIcon"
        class="nav-menu-svg-icon mx-auto"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path v-for="path in svgIcon.paths" :key="path" :d="path" />
        <circle
          v-for="circle in svgIcon.circles"
          :key="`${circle.cx}-${circle.cy}-${circle.r}`"
          :cx="circle.cx"
          :cy="circle.cy"
          :r="circle.r"
        />
      </svg>

      <v-icon v-else :class="{'alternate-icon-small': !icon}" class="mx-auto">
        {{ icon || alternateIcon }}
      </v-icon>
    </v-list-item-icon>

    <v-list-item-title>
      {{ title }}
    </v-list-item-title>
  </v-list-item>
</template>

<script>
import { mdiCheckboxBlankCircleOutline } from '@mdi/js'

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    svgIcon: {
      type: Object,
      default: undefined,
    },
    icon: {
      type: String,
      default: undefined,
    },
  },

  setup() {
    return {
      alternateIcon: mdiCheckboxBlankCircleOutline,
    }
  },
}
</script>

<style lang="scss" scoped>
.alternate-icon-small {
  font-size: 14px;
  height: 14px;
  width: 14px;
}

.nav-menu-svg-icon {
  display: block;
  flex: 0 0 auto;
}

.vertical-nav-menu-link {
  .v-list-item__title {
    font-size: 0.83rem;
  }

  &.v-list-item--active {
    box-shadow: 0 5px 10px -4px rgba(94, 86, 105, 0.42);
    @include elevationTransition();
  }
}
</style>
